import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2feeaece&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&id=2feeaece&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=2feeaece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feeaece",
  null
  
)

export default component.exports